import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

export interface ExcelExportColumn {
  key: string;
  label: string;
}

// Shared by any p-table "Export to Excel" button (projects, tasks, ...) - mirrors
// TablePdfExportService: callers resolve the currently-filtered/visible rows and format each cell
// the same way the table itself renders it, then hand that off here to build and download the sheet.
@Injectable({
  providedIn: 'root'
})
export class TableExcelExportService {

  Export(sheetName: string, columns: ExcelExportColumn[], rows: string[][], filename: string) {
    const worksheet = XLSX.utils.aoa_to_sheet([columns.map(c => c.label), ...rows]);

    // Reasonable column widths from content length so the sheet isn't unreadably cramped by default.
    worksheet['!cols'] = columns.map((c, i) => {
      const longest = rows.reduce((max, row) => Math.max(max, (row[i] || '').length), c.label.length);
      return { wch: Math.min(Math.max(longest + 2, 10), 60) };
    });

    const workbook = XLSX.utils.book_new();
    // Excel sheet names are capped at 31 characters.
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.substring(0, 31));
    XLSX.writeFile(workbook, filename);
  }
}
